import XLSX from 'xlsx'
export default {
  data () {
    return {
      archivedFields: [
        {
          prop: 'taskid',
          label: '任务ID',
          formatter: row => 'TSK' + row.taskid
        },
        {
          prop: 'title',
          label: '任务标题'
        },
        {
          prop: 'type',
          label: '任务类型',
          formatter: (row) => this.getOptionLabel('allType', row.type)
        },
        {
          prop: 'assignnum',
          label: '完成人'
        },
        {
          prop: 'salary',
          label: '赏金',
          formatter: row => filter.hasPermission(250) ? row.salary : '*'
        },
        {
          prop: 'starttime_endtime',
          label: '任务时间',
          formatter: row => `${row.starttime}\n${row.endtime}`,
          width: '160px'
        },
        {
          prop: 'city',
          label: '城市',
          formatter: row => `${row.provincename}${row.cityname}${row.areaname}`,
        },
        {
          prop: 'marketname',
          label: '门店名称'
        },
        {
          prop: 'status',
          label: '任务状态',
          formatter: (row) => this.getOptionLabel('status', row.status)
        },
        {
          prop: 'adminname',
          label: '任务发布人'
        },
        {
          prop: 'customerid',
          label: '所属客户',
          formatter (row) {
            return row.customerid ? (row.customer_name + '/' + row.customer_number) : '平台'
          }
        },
        {
          prop: 'publishtime',
          label: '发布时间',
          formatter: row => `${row.publishtime}`,
          width: '160px'
        },
      ],
      orderArchivedFields: [
        {
          prop: 'orderid',
          label: '工单ID',
          formatter: row => 'ORD' + row.orderid,
        },
        {
          prop: 'title',
          label: '任务标题'
        },
        {
          prop: 'type',
          label: '任务类型',
          formatter: (row) => this.getOptionLabel('allType', row.type)
        },
        {
          prop: 'userid',
          label: '完成人'
        },
        {
          prop: 'salary',
          label: '赏金',
          formatter: row => filter.hasPermission(250) ? row.salary : '*'
        },
        {
          prop: 'starttime_endtime',
          label: '任务时间',
          formatter: row => `${row.starttime}\n${row.endtime}`,
          width: '160px'
        },
        {
          prop: 'city',
          label: '城市',
          formatter: row => `${row.provincename}${row.cityname}${row.areaname}`,
        },
        {
          prop: 'marketname',
          label: '门店名称'
        },
        {
          prop: 'status',
          label: '任务状态',
          formatter: (row) => this.getOptionLabel('status', row.status)
        },
        {
          prop: 'adminname',
          label: '任务发布人'
        },
        {
          prop: 'customerid',
          label: '所属客户',
          formatter (row) {
            return row.customerid ? (row.customer_name + '/' + row.customer_number) : '平台'
          }
        },
        {
          prop: 'review',
          label: '审核次数',
        },
        {
          prop: 'publishtime',
          label: '发布/更新时间',
          formatter: row => `${row.publishtime}\n${row.lastupdatetime || ''}`,
          width: '160px'
        }
      ]
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
  },
  methods: {
    onUploadFile (file, taskType, fileType = 6) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (taskType === 231) {
        fileType = 8
      }

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('collection_type', 2) // 集合类型为2
      formData.append('type', taskType)
      formData.append('file_type', fileType)

      request.common('createTaskBatch', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },

    createTaskBatch (file) {
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('createTaskBatchJob', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    createTaskBatchWithTemplate (file) {
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('createTaskWithTemplateBatchJob', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    uploadAuditReferenceBatch (file) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('importTaskAuditReferenceBatchJob', formData).then(() => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    editTaskBatch (file) {
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('editTaskBatchJob', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    deleteTaskBatch (file) {
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('deleteTaskBatchJob', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    reactivateTaskBatch (file) {
      let formData = new FormData()
      formData.append('file', file.raw)

      request.common('reactivateTaskBatchJob', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    // 解析上传的excel文件 看一下是否超过MaxRowLimit
    parseExcelFile (file, maxRowLimit = 20000) {
      return new Promise((resolve, reject) => {
        let isSatisfy = true
        let errorMessage = ''
        // 先校验一下文件的大小
        let isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          isSatisfy = false
          errorMessage = '上传表格行数超过10M，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。'
          return resolve({isSatisfy, errorMessage})
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })

            const firstSheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[firstSheetName]

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
            // 计算数据条数，减去第一行标题
            const rowCount = jsonData.length - 1
            // 超过限定的长度
            if (rowCount > maxRowLimit) {
              isSatisfy = false
              errorMessage = `上传表格行数超过${maxRowLimit}条，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。`
            } else {
              isSatisfy = true
            }
            return resolve({isSatisfy, errorMessage})
          } catch (error) {
            reject(Error(`文件解析失败: ${error.message}`))
            throw new Error(error)
          }
        }
        reader.onerror = () => {
          reject(Error('文件读取失败'))
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 上传任务可执行时间段 需要先校验一下他的行数
    async taskAvailableTimeBatch (file) {
      try {
        this.$store.commit('OPEN_LOADING')
        const {isSatisfy, errorMessage} = await this.parseExcelFile(file.raw, 20000)
        this.$store.commit('CLOSE_LOADING')
        // 超过限制 提示
        if (!isSatisfy) {
          try {
            await this.$confirm(
              errorMessage,
              '警告',
              {
                type: 'warning',
                confirmButtonText: '已联系，继续操作',
                cancelButtonText: '取消',
              }
            )
            await this.uploadTaskAvailableTimeBatch(file)
          } catch (error) {
            this.$message.info('已取消上传')
            throw new Error(error)
          }
        } else {
          // 限制内 正常上传
          await this.uploadTaskAvailableTimeBatch(file)
        }
      } catch (error) {
        this.$message.error(error)
        throw new Error(error)
      }
    },
    // 上传excel
    async uploadTaskAvailableTimeBatch (file) {
      let formData = new FormData()
      formData.append('file', file.raw)
      await request.common('taskAvailableTimeBatchJob', formData)
      this.$message({
        showClose: true,
        message: '上传成功',
        type: 'success'
      })
      this.onSearch()
    },
    // 任务可执行时间端 点击
    confirmTaskAvailableTimeBatch (e) {
      e.stopPropagation()
      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },
    async onPublishTask (task) {
      if (moment(task.taskendtime).isBefore(moment())) {
        this.$message.error('任务结束时间必须大于当前时间')
      } else {
        let totalSalary = _.round(task.hirenum * task.salary, 2)
        await this.$prompt(`任务[${task.taskid}]的报酬${task.salary}元，需要${task.hirenum}人，请输入总金额：${totalSalary}`, '提示', {
          confirmButtonText: '发布',
          cancelButtonText: '取消',
          inputPattern: new RegExp('^' + totalSalary + '$'),
          inputErrorMessage: '金额输入错误',
          inputPlaceholder: totalSalary,
          closeOnClickModal: false
        })

        await request.alert('taskPublish', {taskid: task.taskid})
        this.$store.commit('OPEN_LOADING')
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve()
            this.$store.commit('CLOSE_LOADING')
          }, 2000)
        })
        await this.onRefresh()

        this.$message({
          showClose: true,
          message: `任务[${task.taskid}]发布成功`,
          type: 'success',
        })
      }
    },
    getOptionLabel (optType, val) {
      const type = this.options[optType].find((one) => one.value === val)
      return type ? type.label : ''
    },
    countDown (date) {
      let futureTs = (Date.parse(date) + '').substr(0, 10)
      let currentTs = ((new Date()).getTime() + '').substr(0, 10)
      let interval = futureTs - currentTs

      if (interval < 0) {
        return ''
      }

      return filter.formatTimerHumanize(interval)
    },
  }
}




// WEBPACK FOOTER //
// ./src/views/task/task.mixins.js